<template>
  <div>
    <p class="note--label">Latest Note</p>
    <p
      v-if="recentNote"
      class="note--body"
      v-html="recentNote.body"
    ></p>
    <p v-else class="note--body is-empty">No recent notes</p>

    <notes-default class="mt-100" :noteable="record"></notes-default>
  </div>
</template>

<script>
export default {
  name: "NotesWithLatest",
  props: {
    record: {
      type: Object,
      required: true
    },
  },
  computed: {
    recentNote() {
      const notes = this.$utils.clone(this.record.notes);
      const sortedNotes = notes.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      return sortedNotes[0];
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.note {

  &--label {
    margin-bottom: 2px;
    font-size: 0.75rem;
    color: $text-muted;
    text-transform: uppercase;
  }

  &--body {
    margin-bottom: 8px;
    line-height: 1.3;

    &.is-empty {
      margin: 10px 0 24px;
      font-style: italic;
    }
  }
}
</style>
